import { Component } from '@angular/core';
import { AndFilter, Filter, FilterOperation, OrFilter } from 'src/app/core/jsonapi/filter';
import { TasksService } from '../_services/tasks.service';
import { Task } from '../_types/task';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { UsersService } from '../../users/_services/users.service';
import { User } from '../../users/_types/user';
import moment from 'moment';
import { LocalStorageService } from 'angular-web-storage';
import { LoginService } from '../../login/login.service';
import { ContractProcessor } from '../../companies/_types/contract-processor';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { ContractProcessorsService } from '../../companies/_services/contracts-processors.service';

@Component({
    selector: 'app-tasks-list',
    templateUrl: './tasks-list.component.html',
    styleUrls: ['./tasks-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class TasksListComponent {
  public tasks: Task[] = [];
  public users: User[] = [];
  public taskStatus: any[] = [
    { label: 'Pendiente', value: false },
    { label: 'Completada', value: true }
  ];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    description: new Filter(FilterOperation.contains, 'description'),
    userId: new Filter(FilterOperation.equals, 'userId'),
    userSelectedId: new Filter(FilterOperation.equals, 'userId'),
    isCompleted: new Filter(FilterOperation.equals, 'isCompleted'),
  };

  public userChip: Filter = new Filter(FilterOperation.equals, 'userId');
  public incomingChip: Filter = new Filter(FilterOperation.equals, 'date');
  public userOptions: { label: string; value: any }[] = [];
  public fieldsConfig: FilterFieldConfig[] = [];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public pendingTask: boolean = false;
  public incomingTasks: boolean = false;
  public today = new Date();

    public user!:User;
  public hasLoadedProcessorContracts: boolean = false;

  public usersSameContractsIds: string[] = [];
  public userSelectedId: string | null = null;
  constructor(
    private tasksService: TasksService,
    private usersService: UsersService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private storage: LocalStorageService,
    public loginService: LoginService,
    private contractProcessorsService: ContractProcessorsService
  ) {
   
    this.allowWrite = this.loginService.hasPermission("TASKS.WRITE");
    this.allowDelete = this.loginService.hasPermission("TASKS.DELETE");
    this.today.setHours(0, 0, 0, 0);
  }

  async ngOnInit(): Promise<void> {
    this.user = this.storage.get('user');
    
   // await this.loadProcessorContracts();

    this.topbarService.setTitle("Tareas");
    this.topbarService.addAction("Nueva", "pi pi-plus", false, () => {
      this.edit({} as Task);
    });

    this.filters.isCompleted.value = false;
    this.filters.userId = new Filter(FilterOperation.equals, 'userId', '', this.user.id)
    this.userSelectedId = this.user.id as string;
    this.userChip.value = this.userSelectedId;
    this.fieldsConfig = [
      { filter: this.filters.description, type: 'text', label: 'Nombre', base: true },
      ...(this.loginService.hasPermission('TASKS.VIEW_OTHER_USERS') ? [{ filter: this.userChip, type: 'select' as const, label: 'Usuario', options: this.userOptions, filterable: true, base: true }] : []),
      { filter: this.filters.isCompleted, type: 'select', label: 'Estado', options: this.taskStatus, base: true },
      { filter: this.incomingChip, type: 'bool', label: 'Próximas tareas', base: true }
    ];
    this.loadUserOptions();

    this.loadUsers();
  }

  async loadProcessorContracts(){

    //console.log("Loading processor contracts for user ", this.userSelectedId);
    //Se busca la información del combo de la pantalla

    let filterP: any = {
      processorId: new Filter(FilterOperation.equals, 'processorId', '', this.userSelectedId)
    };
    let paramsP:IParamsCollection = {
      filter: FilterBuilder.fromObject(filterP).build()
    };
    let responseP = await firstValueFrom(this.contractProcessorsService.all(paramsP));
    let processorContractIds = responseP.data.map(pc => pc.contractId);

    //los tramitadores de los mismos contratos que el usuario
    let filtersCases = {
      contractId: new Filter(FilterOperation.any, 'contractId', "", processorContractIds)        
    };  
    let paramsCases: IParamsCollection = { page: { number: 1, size: 2000}}
    //creamos filtros
    paramsCases.filter = FilterBuilder.fromObject(filtersCases).build();
    var contractProcessorsAll = await firstValueFrom(this.contractProcessorsService.all(paramsCases)).then(response => response.data);
    
    this.usersSameContractsIds = contractProcessorsAll.filter((v, i, a) => a.findIndex(t => (t.processorId === v.processorId)) === i).map(cp => cp.processorId);

    //añadimos a el mismo
    this.usersSameContractsIds.push(this.userSelectedId as string);
    
    //console.log("Users with same contracts ids: ", this.usersSameContractsIds);
    
    this.hasLoadedProcessorContracts = true;
  }

  public async loadData($event: any) {

    this.userSelectedId = this.userChip.value ?? this.user.id as string;
    this.incomingTasks = this.incomingChip.value === true; //Tengo mis dudas, no se si deberia permitir por todo el mundo... por ahora solo a´si 

    //if(this.hasLoadedProcessorContracts == false){
    //Se comenta por si cambia el usuario del combo.
      await this.loadProcessorContracts();
    //}
    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
      include: ['user', 'caseNote', 'createdByUser'],
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //filtro de gente ausente
    if(this.usersSameContractsIds.length> 0){
       this.filters['userId'] = new OrFilter([
              new Filter(FilterOperation.equals, 'userId', '', this.userSelectedId),
              new AndFilter([
                new Filter(FilterOperation.equals, 'user.absence', '', true),
                new Filter(FilterOperation.any, 'userId', '', (this.usersSameContractsIds.length>0?this.usersSameContractsIds:null))
              ])
          ]);
    }else{
       this.filters['userId'] = new OrFilter([
          new Filter(FilterOperation.equals, 'userId', '', this.userSelectedId)
      ]);
    }
    

    if (!this.incomingTasks) {
      let today = moment({ h: 23, m: 59, s: 59, ms: 0 }).format('YYYY-MM-DD HH:mm:ss');
      this.filters.date = new Filter(FilterOperation.lessOrEqual, 'date', '', today);
    } else {
      this.filters.date = undefined;
    }

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();


    let response = await firstValueFrom(this.tasksService.all(params));
    this.tasks = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  private async loadUserOptions() {
    let filters = { isWorker: new Filter(FilterOperation.equals, 'isWorker', '', false) };
    let response = await firstValueFrom(this.usersService.all({ page: { size: 1000, number: 1 }, sort: ['name'], fields: { users: 'name' }, filter: FilterBuilder.fromObject(filters).build() }));
    this.userOptions.length = 0;
    this.userOptions.push(...response.data.map((u: any) => ({ label: u.name, value: u.id })));
  }

  async loadUsers(event?: any) {
     let text = "";
    if (event != null) text = event.filter; 
    let filters = {
      name: new Filter(FilterOperation.contains, 'name', '', text),
      isWorker: new Filter(FilterOperation.equals, 'isWorker', '', false) 
    };
    let params: IParamsCollection = {
      page: { size: 100, number: 1 },
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.usersService.all(params));
    this.users = response.data;
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }


  edit(task: Task) {
    this.router.navigate(['tasks/' + (task && Object.keys(task).length > 0 ? task.id : 0)]);
  }

  delete(task: Task) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la tarea?",
        header: "Eliminar tarea",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.tasksService.delete(task.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Tarea eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }
}
